import { ReactElement } from 'react';
import { ChatMessage } from '../../api/graphql/generated';
import './chat.css';
import { ConversationMessage } from './conversation-message';

interface ConversationReplyListProps {
  replies: ChatMessage[];
}

const ConversationReplyList = (
  props: ConversationReplyListProps
): ReactElement => {
  const { replies } = props;

  return (
    <div className={'threaded-message'}>
      {replies.map((r) => {
        return <ConversationMessage key={r.id} conversation={r} />;
      })}
    </div>
  );
};

export { ConversationReplyList };
